"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6420],{

/***/ 83877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ AuthInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28482);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28973);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var AuthInput = function(param) {
    var type = param.type, name = param.name, label = param.label, onClick = param.onClick, _options = param.options, options = _options === void 0 ? [] : _options, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, errorMessage = param.errorMessage;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (errorMessage) {
            setErrorState(true);
        }
    }, [
        errorMessage
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), errorState = ref[0], setErrorState = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "w-full",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label)),
                children: label
            }),
            type === "select" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                placeholder: placeholder,
                as: "select",
                name: name,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input)),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: option.value.toUpperCase(),
                        children: option.label
                    }, option.value);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                placeholder: placeholder,
                onInput: function() {
                    return setErrorState(false);
                },
                name: name,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputError), errorState)),
                type: type
            }),
            errorState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputErrorMessage)),
                children: errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 88462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Login; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72276);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50594);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22550);
/* harmony import */ var _AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83877);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28973);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28482);
/* harmony import */ var _public_fb_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28829);
/* harmony import */ var _utils_GoogleAuth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51664);
/* harmony import */ var react_facebook_login_dist_facebook_login_render_props__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18228);
/* harmony import */ var react_facebook_login_dist_facebook_login_render_props__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_facebook_login_dist_facebook_login_render_props__WEBPACK_IMPORTED_MODULE_9__);











// import { AuthCheckbox } from '../AuthCheckbox/AuthCheckbox';






var Login = function(param) {
    var changeState = param.changeState, authCompleted = param.authCompleted, _darkMode = param.darkMode, darkMode = _darkMode === void 0 ? false : _darkMode, sourcePage = param.sourcePage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), existingUsername = ref2[0], setExistingUsername = ref2[1];
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.user) === null || ref === void 0 ? void 0 : ref.value;
    });
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (userStore && userStore.existingUser) {
            setExistingUsername(userStore.existingUser);
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.existingUser
    ]);
    var login = function(values) {
        var external = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setLoading(true);
        setErrorMessage(null);
        (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_10__/* .httpPost */ .Ko)(external ? "/api/login/".concat(external) : "/api/login", values).then(function(response) {
            setLoading(false);
            if (response.ok) {
                var tagManagerArgs = {
                    dataLayer: {
                        event: "login",
                        userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                        pageType: router === null || router === void 0 ? void 0 : router.pathname
                    }
                };
                react_gtm_module__WEBPACK_IMPORTED_MODULE_4___default().dataLayer(tagManagerArgs);
                // authCompleted();
                if (external) {
                    response.json().then(function(res) {
                        if (res.isNewUser) {
                            var tagManagerArgs = {
                                dataLayer: {
                                    event: "accountCreated",
                                    userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                                    pageType: router === null || router === void 0 ? void 0 : router.pathname,
                                    source: external,
                                    membershipId: userStore === null || userStore === void 0 ? void 0 : userStore.membershipNumber,
                                    signupSource: sourcePage
                                }
                            };
                            react_gtm_module__WEBPACK_IMPORTED_MODULE_4___default().dataLayer(tagManagerArgs);
                            changeState("setAirport");
                        } else {
                            authCompleted();
                        }
                    });
                } else {
                    authCompleted();
                }
                return;
            } else {
                if (!external) {
                    setErrorMessage("Wrong email or password \n");
                }
            }
        }, function(error) {
            setLoading(false);
            setErrorMessage("Server error: ".concat(error));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: darkMode ? (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().authDarkTheme) : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_12__/* .Formik */ .J9, {
            initialValues: {
                username: existingUsername ? existingUsername : "",
                password: "",
                remember_me: true
            },
            onSubmit: function(values) {
                login((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, values), {
                    remember_me: Number(values["remember_me"])
                }));
            },
            className: "flex flex-col items-center",
            children: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_12__/* .Form */ .l0, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().subHeader), "text-center font-libre"),
                            children: "The Club"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().header), "text-center my-4 font-fragment"),
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().fieldInfo)),
                            children: existingUsername && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "Account for ",
                                    existingUsername,
                                    " already created. Try to login with it or use the Reset password for recovery"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-sm flex flex-col items-center mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_6__/* .AuthInput */ .Y, {
                                    name: "username",
                                    type: "text",
                                    label: "Email"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_6__/* .AuthInput */ .Y, {
                                    name: "password",
                                    type: "password",
                                    label: "Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col text-center justify-center w-full mt-4 mb-8"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    onClick: function() {
                                        return changeState("passwordReset");
                                    },
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().forgotPassword),
                                    children: "Forgot password?"
                                }),
                                errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().error),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            color: "inherit",
                                            onClick: function() {
                                                return setErrorMessage(null);
                                            },
                                            "aria-label": "close",
                                            className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().closeDialog),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                errorMessage,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " Try again or create a new password \xa0",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().errorLink),
                                                    onClick: function() {
                                                        return changeState("passwordReset");
                                                    },
                                                    children: "here."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().loader)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "submit",
                                    disabled: loading,
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().loginButton), "text-white font-serif mx-auto"),
                                    children: "Login"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().snLogin), "flex justify-center items-center"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mr-5",
                                    children: "or login with"
                                }),
                                 false && /*#__PURE__*/ 0,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_GoogleAuth__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    styles: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().snGoogleButton),
                                    // callback on response
                                    handleCredentialResponse: function(res) {
                                        return login({
                                            token: res.credential
                                        }, "google");
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_11___default().haveAccount)),
                            children: [
                                "New to First-Class.com? ",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    onClick: function() {
                                        return changeState("signUp");
                                    },
                                    children: "Join The Club for free"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};


/***/ }),

/***/ 12930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PasswordRecovery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72276);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50594);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22550);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28973);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83877);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);










var PasswordRecovery = function(param) {
    var changeState = param.changeState, _darkMode = param.darkMode, darkMode = _darkMode === void 0 ? false : _darkMode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), userEmail = ref3[0], setUserEmail = ref3[1];
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.value;
    });
    var resetPassword = function(values) {
        setUserEmail(values.user);
        setLoading(true);
        (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_5__/* .httpPost */ .Ko)("/api/user/recoveryEmail", {
            email: values.user
        }).then(function(res) {
            if (res.ok) {
                setSuccess(true);
                setErrorMessage(null);
            } else {
                if (userStore.country === "NO" || userStore.country === "SE" || userStore.country === "DK") {
                    setErrorMessage("This email is not registered on First-Class.com or other error happened");
                } else {
                    setErrorMessage("This email is not registered on First-Class.com");
                }
            }
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: darkMode ? (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().authDarkTheme) : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Formik */ .J9, {
            initialValues: {
                user: ""
            },
            onSubmit: function(values) {
                resetPassword(values);
            },
            className: "flex flex-col items-center",
            children: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, {
                    children: [
                        !success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header), "text-center my-4 font-fragment"),
                            children: "Forgot Password"
                        }),
                        success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header), "text-center my-4 font-fragment"),
                            children: "Check your email"
                        }),
                        !success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fieldInfo)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Please enter email which you have been using for First-Class.com."
                            })
                        }),
                        success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fieldInfo)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "We’ve sent you an email to ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: userEmail
                                        }),
                                        " to reset your password."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "If you don’t see an email from us within a few minutes, please check your spam folder and the email address you provided."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "mt-4",
                                    children: [
                                        "If the email has not arrived, please try again to ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: function() {
                                                return setSuccess(false);
                                            },
                                            className: "cursor-pointer",
                                            children: "reset password"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-sm flex flex-col items-center mx-auto",
                            children: [
                                !success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_3__/* .AuthInput */ .Y, {
                                    name: "user",
                                    label: "Email"
                                }),
                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loader)
                                }),
                                errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            color: "inherit",
                                            onClick: function() {
                                                return setErrorMessage(null);
                                            },
                                            "aria-label": "close",
                                            className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().closeDialog),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: errorMessage
                                        })
                                    ]
                                }),
                                !success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loginButton), "text-white font-serif mx-auto"),
                                    children: "Reset password"
                                }),
                                !success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    onClick: function() {
                                        return changeState("login");
                                    },
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().forgotPassword),
                                    children: "Cancel"
                                }),
                                success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    onClick: function() {
                                        return changeState("login");
                                    },
                                    className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().forgotPassword),
                                    children: "Back to login"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};


/***/ }),

/***/ 55311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SetPassword; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22550);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28973);
/* harmony import */ var _Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83877);







// import { useRouter } from 'next/router';
// import TagManager from 'react-gtm-module';
// import { useSelector } from 'react-redux';



var validationSchema = (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)().shape({
    password: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required("Password is required"),
    passwordRepeat: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().oneOf([
        (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .ref */ .iH)("password"),
        null
    ], "Passwords must match").required("Repeat password is required")
});
var SetPassword = function(param) {
    var props = param.props, authCompleted = param.authCompleted, changeState = param.changeState, _darkMode = param.darkMode, darkMode = _darkMode === void 0 ? false : _darkMode;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = _$ref[0], setLoading = _$ref[1];
    // const userStore = useSelector((state) => state.user?.value);
    // const router = useRouter();
    var setPassword = function(value) {
        setLoading(true);
        (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_5__/* .httpPost */ .Ko)("/api/user/reset", {
            password: value.password
        }).then(function(resolve) {
            if (resolve.ok) {
                setLoading(false);
                authCompleted();
                changeState("setAirport");
            // const tagManagerArgs = {
            //   dataLayer: {
            //     event: 'accountCreated',
            //     userCountry: userStore?.country.toUpperCase(),
            //     pageType: router?.pathname,
            //     membershipId: userStore?.membershipNumber,
            //     signupSource: sourcePage
            //   },
            // };
            // TagManager.dataLayer(tagManagerArgs);
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: darkMode ? (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().authDarkTheme) : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Formik */ .J9, {
            initialValues: {
                passwordRepeat: "",
                password: ""
            },
            validationSchema: validationSchema,
            onSubmit: function(values) {
                setPassword(values);
            },
            className: "flex flex-col items-center",
            children: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                        className: "flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header), "text-center my-4 font-fragment"),
                                children: "Set your password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-sm flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_4__/* .AuthInput */ .Y, {
                                        name: "password",
                                        type: "password",
                                        label: "Password"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .ErrorMessage */ .Bc, {
                                        name: "password",
                                        component: "div",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputErrorMessage), "text-left")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthInput_AuthInput__WEBPACK_IMPORTED_MODULE_4__/* .AuthInput */ .Y, {
                                        name: "passwordRepeat",
                                        type: "password",
                                        label: "Repeat password"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .ErrorMessage */ .Bc, {
                                        name: "passwordRepeat",
                                        component: "div",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputErrorMessage), "text-left")
                                    }),
                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loader)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "submit",
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Authentication_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loginButton), "text-white font-serif mx-auto"),
                                        children: "Continue"
                                    })
                                ]
                            })
                        ]
                    }))
                });
            }
        })
    });
};


/***/ })

}]);